/* HIG-149: instant cart-drawer delivery line.
 * The delivery line used to appear only after warehouse-cart-reconcile.js wrote the
 * Verfügbarkeit property via a server round-trip (~1–2 s lag + layout shift). The same vb
 * data is already in the drawer DOM the moment it renders, so we render the line instantly
 * from it (via the shared window.HPDeliveryText formatter — identical text + logic to the
 * property that is still written for checkout).
 *
 * Cart-Schreibzugriff (bewusste Aufweichung des früheren «read-only on the cart»,
 * Plan Teillieferungs-Checkbox 2026-08-09, CART_DRAWER_REFRESH.md): Dieses Script
 * schreibt in GENAU ZWEI Fällen in den Cart — (a) der Kunde schaltet die
 * Teillieferungs-Checkbox um (Gebühren-Produkt rein/raus + Cart-Attribut), (b)
 * Auto-Aufräumen: liegt kein verzögerter Artikel mehr im Korb, wird eine noch
 * vorhandene Gebühren-Zeile entfernt. Alles andere bleibt read-only. */
(function () {
  if (window.__hpCartDeliveryInstalled) return;
  window.__hpCartDeliveryInstalled = true;

  var processing = false;

  // Lieferzeit-Redesign 2026-07 (LIEFERZEIT_KONZEPT.md): Der Haken trägt die
  // icon_color seiner STUFE (grün nur sofort, schwarz Tage, grau Wochen), der
  // Text die Standardfarbe — grüner TEXT nur bei «sofort». Die Stufe wird aus
  // dem Property-Text erkannt (Katalog-Abgleich über alle Sprachen), weil die
  // Property nur Text transportiert.
  function tierMetaFor(rest) {
    var core = window.HPDeliveryCore;
    var cat = core && core.LABEL_CATALOG;
    if (!cat) return null;
    var r = String(rest).toLowerCase();
    // WICHTIG (Bugfix 2026-07-30): Die LÄNGSTE Katalog-Übereinstimmung gewinnt.
    // Die instant-Labels («ready to ship», «prêt à expédier», …) sind PRÄFIXE
    // aller langsameren Labels derselben Sprache — ein First-Match hielt darum
    // z.B. «ready to ship in 7 to 9 days» für instant und färbte die Zeile grün
    // (Tobias-Befund im EN-Cart). Längster Treffer = präzisester Treffer.
    var bestKey = null, bestLen = 0;
    var keys = Object.keys(cat.de);
    for (var k = 0; k < keys.length; k++) {
      var key = keys[k];
      for (var l = 0; l < 4; l++) {
        var loc = ['de', 'en', 'fr', 'it'][l];
        var m = cat[loc] && cat[loc][key];
        if (!m) continue;
        var lab = String(m.label_lower).toLowerCase();
        if (lab.length > bestLen && r.indexOf(lab) !== -1) {
          bestLen = lab.length;
          bestKey = key;
        }
      }
    }
    return bestKey ? core.lookupLabel(bestKey) : null;
  }
  // Farbregel VEREINHEITLICHT (Entscheid Tobias 2026-08-02): Kategoriekarte,
  // Produktseite und SliderCart zeigen dieselbe Stufe in derselben Farbe. Der
  // Text nimmt darum `color` aus dem Stufen-Katalog (grün #4EA72E sofort,
  // schwarz #222222 Tage, grau #8a8a8a Wochen), der Haken wie bisher
  // `icon_color`. Vorher war der Text bei allem ausser «sofort» auf #404040
  // festgenagelt — dadurch war der SliderCart als einziger Kontaktpunkt grau,
  // während Karte und PDP #222222 zeigten. #404040 bleibt nur der Notnagel,
  // wenn der Katalog die Stufe nicht erkennt.
  function lineColors(rest) {
    var meta = tierMetaFor(rest);
    if (!meta) return { ic: '#222222', tx: '#404040' };
    return { ic: meta.icon_color || '#222222', tx: meta.color || '#404040' };
  }
  function esc(s) { var d = document.createElement('div'); d.textContent = s; return d.innerHTML; }

  // Auch SSR-gerenderte Zeilen (cart-items.liquid) nachfärben — der Server kennt
  // die Stufe nicht (Property = reiner Text) und rendert neutral. Gibt false
  // zurück, solange der Katalog (HPDeliveryCore) noch nicht geladen ist — dann
  // wird der Container NICHT als erledigt markiert und der nächste run()-Pass
  // (DOMContentLoaded/Events) färbt nach. (Bugfix 2026-07-30: dieses Script kann
  // vor hp-delivery-core.js laufen; vorher blieben SSR-Zeilen dauerhaft neutral,
  // «sofort versandfertig» war nach einem Reload nie grün.)
  function colorizeExisting(container) {
    if (!window.HPDeliveryCore || !window.HPDeliveryCore.LABEL_CATALOG) return false;
    container.querySelectorAll('dd').forEach(function (dd) {
      var icEl = dd.querySelector('.hp-cdl-ic') || dd.querySelector('span:first-child');
      var txEl = dd.querySelector('.hp-cdl-tx') || dd.querySelector('span:last-child');
      if (!icEl || !txEl || icEl === txEl) return;
      var c = lineColors(txEl.textContent || '');
      icEl.style.color = c.ic;
      dd.style.color = c.tx;
    });
    return true;
  }

  // SSR-Zeilen zum Property-Text rekonstruieren («✓ 1 Stück …, ✓ 2 Stück …»),
  // um ihn gegen die aktuelle Menge zu validieren (HPDeliveryTextValid).
  function ssrText(container) {
    return [].map.call(container.querySelectorAll('dd'), function (dd) {
      var ic = dd.querySelector('.hp-cdl-ic, span:first-child');
      var tx = dd.querySelector('.hp-cdl-tx, span:last-child');
      return ((ic ? ic.textContent : '') + ' ' + (tx ? tx.textContent : '')).trim();
    }).join(', ');
  }

  // AKTUELLE Menge der Position: Der Drawer patcht beim Mengen-Klick nur das
  // Eingabefeld — Container samt data-qty und alter Property bleiben stehen
  // (Bugfix 2026-07-30, Red-Team-Fund). Darum die Menge live aus dem
  // quantity-input derselben Position lesen; data-qty ist nur Fallback.
  function currentQty(container) {
    // Streng auf die EIGENE Position begrenzen: nur bis zur Zeilen-Ebene (tr/li)
    // hochlaufen und abbrechen, sobald ein Element mehrere Positionen enthält —
    // sonst griffe der Walk das Mengenfeld des PDP-Produktformulars ab.
    var el = container;
    for (var i = 0; i < 6 && el; i++) {
      if (el.querySelectorAll && el.querySelectorAll('[data-hp-cart-delivery]').length > 1) break;
      var inp = el.querySelector && el.querySelector('quantity-input input');
      if (inp && inp.value) return inp.value;
      if (el.tagName === 'TR' || el.tagName === 'LI') break;
      el = el.parentElement;
    }
    return container.getAttribute('data-qty');
  }

  function renderFromVb(container, qty) {
    var text = window.HPDeliveryText
      ? window.HPDeliveryText(container.getAttribute('data-vid'), qty)
      : null;
    if (!text) { container.style.minHeight = '0'; return; } // no delivery data → collapse, no gap
    var parts = text.split(', ');
    var html = '';
    for (var i = 0; i < parts.length; i++) {
      var p = parts[i].trim();
      if (!p) continue;
      var icon = p.charAt(0);
      var rest = p.slice(1).trim();
      var c = lineColors(rest);
      html += '<dd class="m-0" style="display:flex;color:' + c.tx +
        ';font-weight:500;"><span class="hp-cdl-ic" style="display:inline-block;flex:0 0 1.3em;width:1.3em;color:' + c.ic + ';">' +
        esc(icon) + '</span><span class="hp-cdl-tx">' + esc(rest) + '</span></dd>';
    }
    container.innerHTML = html;
  }

  function fill(container) {
    if (!window.HPDeliveryCore || !window.HPDeliveryCore.LABEL_CATALOG) return; // Katalog noch nicht da → nächster Pass
    var qty = currentQty(container);
    var hasContent = container.children.length || container.textContent.trim();
    if (hasContent) {
      // Inhalt (SSR oder frühere Client-Renderung) gegen die AKTUELLE Menge
      // validieren; passt er nicht mehr → frisch aus dem vb rendern.
      var stale = window.HPDeliveryTextValid
        ? !window.HPDeliveryTextValid(container.getAttribute('data-vid'), qty, ssrText(container))
        : false;
      if (!stale) {
        if (container.getAttribute('data-hp-filled') !== '1' && colorizeExisting(container)) {
          container.setAttribute('data-hp-filled', '1');
        }
        return;
      }
      renderFromVb(container, qty);
      container.setAttribute('data-hp-filled', '1');
      return;
    }
    renderFromVb(container, qty);
    container.setAttribute('data-hp-filled', '1');
  }

  // Cart-Kopfzeile (Lieferzeit-Redesign 2026-07, Entscheid Tobias): Zustellfenster
  // des LANGSAMSTEN Artikels im Korb. Alles sofort → datiert wie bisher («morgen»/
  // Datum, 17-Uhr-Cutoff via etaWindowText('instant')); langsamster Artikel eine
  // Stufe → deren Datumsfenster; made_to_order → «Lieferung in ca. X bis Y
  // Monaten». Versteckt, wenn keine Zeile Lieferdaten hat.
  // (Ersetzt den alten ✓-Erstzeichen-Check, der seit dem Haken-Redesign 06/2026
  // JEDEN Korb für «alles sofort» hielt und fälschlich «morgen» zeigte.)
  // Erklär-Pille (CART_ZUSTELLUNG_FOOTER.md, Entscheid Tobias 2026-08-09):
  // %L = Zeitteil der Stufe, abgeleitet aus label_lower ohne die Basis-Phrase
  // («versandfertig in 7 bis 9 Tagen» → «in 7 bis 9 Tagen»). Die Basis-Phrasen
  // sind pro Sprache fix; fehlt sie im Label (z.B. künftige Katalog-Änderung),
  // liefert stageTimePart null und die Pille bleibt lieber leer als falsch.
  var PILL_BASE = { de: 'versandfertig ', en: 'ready to ship ', fr: 'prêt à expédier ', it: 'pronto per la spedizione ' };
  function stageTimePart(key) {
    var core = window.HPDeliveryCore;
    var meta = core.lookupLabel(key);
    if (!meta) return null;
    var base = PILL_BASE[core.activeLocale] || PILL_BASE.de;
    var lab = String(meta.label_lower);
    var idx = lab.toLowerCase().indexOf(base.toLowerCase());
    if (idx === -1) return null;
    return lab.slice(idx + base.length);
  }
  function numberWord(n) {
    var core = window.HPDeliveryCore;
    var words = (core.NUMBER_WORDS && core.NUMBER_WORDS[core.activeLocale]) || [];
    return (n >= 2 && n <= 12 && words[n - 2]) ? words[n - 2] : String(n);
  }
  // Pillen-Text nach Fall-Matrix. delayed = pro verzögerter Position die
  // langsamste Nicht-sofort-Stufe; totalPos = Positionen mit Lieferdaten.
  function pillTextFor(delayed, totalPos) {
    var core = window.HPDeliveryCore;
    var cat = core.PILL_STR && (core.PILL_STR[core.activeLocale] || core.PILL_STR.de);
    if (!cat || !delayed.length) return null;
    if (delayed.length === 1) {
      var d0 = delayed[0];
      if (d0.key === 'made_to_order') {
        return (totalPos === 1 ? cat.mto_single : cat.mto_one)
          .replace('%M', core.mtoCompactSuffix(d0.months_min, d0.months_max));
      }
      var tp = stageTimePart(d0.key);
      return tp ? (totalPos === 1 ? cat.single_only : cat.one).replace('%L', tp) : null;
    }
    var sameKey = true;
    for (var i = 1; i < delayed.length; i++) { if (delayed[i].key !== delayed[0].key) { sameKey = false; break; } }
    if (sameKey && delayed[0].key !== 'made_to_order') {
      var tp2 = stageTimePart(delayed[0].key);
      if (tp2) return cat.many.replace('%N', numberWord(delayed.length)).replace('%L', tp2);
    }
    return cat.mixed.replace('%N', numberWord(delayed.length));
  }
  function setPill(el, text) {
    // Gleiche Mutations-Bremse wie bei der Kopfzeile: nur schreiben, wenn sich
    // etwas ändert (MutationObserver-Schleifen-Schutz). Der Text lebt seit der
    // Teillieferungs-Checkbox in einem eigenen Span, damit textContent-Writes
    // die Checkbox-Zeile daneben nicht wegräumen.
    if (!el) return;
    var textEl = el.querySelector('[data-hp-cart-eta-pill-text]') || el;
    if (text) {
      if (textEl.textContent !== text) textEl.textContent = text;
      if (el.hidden) el.hidden = false;
    } else if (!el.hidden) { el.hidden = true; }
  }

  // ── Teillieferungs-Checkbox (Plan 2026-08-09, Mockup Runde 15) ────────────
  // Gebühren-Produkt «teillieferung»: Checkbox rein = /cart/add.js, raus =
  // /cart/change.js qty 0; zusätzlich Cart-Attribut _hp_teillieferung als
  // redundantes Signal (das harte Signal fürs Lager ist die bezahlte Position).
  // Der Haken selbst wird SERVERSEITIG gerendert (cart-drawer.liquid liest den
  // Cart) — hier läuft nur Sichtbarkeit, Label und das Umschalten.
  var teilBusy = false;
  var teilCleanupTries = 0;
  function teilRoot() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }
  function teilSections() {
    // Muster hp-collection-card.js: Sections mitbestellen und den Drawer aus der
    // Antwort rendern — so erscheint/verschwindet die Gebühren-Zeile sichtbar.
    var drawer = document.querySelector('cart-drawer');
    var sections = 'cart-icon-bubble,free-shipping-notice';
    var drawerSection = drawer && drawer.closest('.shopify-section');
    if (drawerSection) sections += ',' + drawerSection.id.replace('shopify-section-', '');
    return { drawer: drawer, sections: sections };
  }
  function teilRender(drawer, result) {
    if (drawer && typeof drawer.renderContents === 'function' && result && result.sections) {
      drawer.renderContents(result, false);
    }
  }
  function teilAttribute(value) {
    // Fire-and-forget: das Attribut ist Redundanz, die Position das harte Signal.
    fetch(teilRoot() + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: { _hp_teillieferung: value } }),
    }).catch(function () {});
  }
  function teilApply(checked, cb) {
    var row = document.querySelector('[data-hp-teil]');
    var input = row && row.querySelector('input');
    if (teilBusy) { if (cb) cb(false); return; }
    teilBusy = true;
    if (input) input.disabled = true;
    var ctx = teilSections();
    var done = function (ok) {
      teilBusy = false;
      if (input) input.disabled = false;
      if (cb) cb(ok);
    };
    if (checked) {
      var vid = row && row.getAttribute('data-hp-teil-vid');
      if (!vid) { done(false); return; }
      fetch(teilRoot() + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(vid), quantity: 1 }], sections: ctx.sections, sections_url: window.location.pathname }),
      })
        .then(function (r) { return r.json().then(function (j) { return { status: r.status, body: j }; }); })
        .then(function (res) {
          if (res.status >= 400 || (res.body && res.body.errors)) { console.warn('[hp-teil] add abgelehnt', res.body); done(false); return; }
          teilAttribute('ja');
          teilRender(ctx.drawer, res.body);
          done(true);
        })
        .catch(function (e) { console.warn('[hp-teil] add fehlgeschlagen', e); done(false); });
    } else {
      // Zeilen-Key der Gebühr aus dem Cart holen, dann Menge 0.
      fetch(teilRoot() + 'cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var line = (cart.items || []).filter(function (i) { return i.handle === 'teillieferung'; })[0];
          if (!line) { teilAttribute(''); done(true); return null; }
          return fetch(teilRoot() + 'cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ id: line.key, quantity: 0, sections: ctx.sections, sections_url: window.location.pathname }),
          })
            .then(function (r) { return r.json().catch(function () { return null; }); })
            .then(function (body) {
              teilAttribute('');
              teilRender(ctx.drawer, body);
              done(true);
            });
        })
        .catch(function (e) { console.warn('[hp-teil] remove fehlgeschlagen', e); done(false); });
    }
  }
  // Einzeiligkeit der Checkbox-Zeile (Design-Entscheid 2026-08-10): volle
  // Schriftgrösse, nur bei ECHTEM Überlauf schrittweise verkleinern — nie
  // pauschal per Media-Query. Bremse über data-hp-fit-key (Breite+Textlänge):
  // ohne Änderung keine Style-Writes (MutationObserver-Loop-Gefahr).
  function teilFitLabel(row, label) {
    var span = label.querySelector('span');
    // Ohne Layout (Breite 0) nicht messen und nichts merken — der nächste
    // Lauf (Load-Event, Cart-Event, Drawer-Mutation, Resize) misst erneut.
    // BEWUSST kein Cache-Key: Ein zu früh gemessener Zustand (CSS noch nicht
    // geladen, Drawer noch nicht gelayoutet) würde sonst eingefroren
    // (Vorfall 2026-08-10: Schrift blieb voll, Text lief über den Boxrand).
    // Style-Writes sind loop-sicher: der Drawer-Observer reagiert nur auf
    // addedNodes (childList), nicht auf Attribute.
    if (!span || row.hidden || !span.getBoundingClientRect().width) return;
    // Echte Textbreite (Range) gegen die Content-Breite des Spans messen —
    // das padding-right des Spans (10px, CSS) wirkt als Luft-Puffer: die
    // Schrift verkleinert sich schon, wenn das Zeilenende dem Boxrand näher
    // als der Puffer käme (Tobias 2026-08-10). scrollWidth taugt dafür nicht,
    // weil es nachlaufendes Padding nicht zuverlässig einrechnet. WICHTIG:
    // getBoundingClientRect (float) statt clientWidth (ganzzahlig) — die
    // Rundung liess die Schleife sonst systematisch «knapp verfehlen» und
    // bis fast zum Minimum weiterschrumpfen (Rundungs-Spirale).
    var textBreite = function () {
      var r = document.createRange();
      r.selectNodeContents(span);
      return r.getBoundingClientRect().width;
    };
    var contentBreite = function () {
      var cs = getComputedStyle(span);
      return span.getBoundingClientRect().width - parseFloat(cs.paddingLeft) - parseFloat(cs.paddingRight);
    };
    span.style.fontSize = '';
    var size = parseFloat(getComputedStyle(span).fontSize) || 16;
    var guard = 0;
    // +0.5px Epsilon: width:fit-content liefert Text- und Content-Breite
    // praktisch identisch (Subpixel) — ohne Epsilon würde grundlos verkleinert.
    while (textBreite() > contentBreite() + 0.5 && size > 10 && guard < 40) {
      size -= 0.25;
      span.style.fontSize = size + 'px';
      guard++;
    }
  }
  window.addEventListener('resize', function () {
    var row = document.querySelector('[data-hp-teil]');
    var label = row && row.querySelector('[data-hp-teil-label]');
    if (row && label) teilFitLabel(row, label);
  });
  // Nach vollständigem Laden (alle Stylesheets aktiv) einmal neu rechnen —
  // frühe Läufe können mit noch fehlendem CSS gemessen haben.
  window.addEventListener('load', function () { run(); });
  // Sichtbarkeit + Label der Checkbox-Zeile; Auto-Aufräumen ohne Verzögerung.
  // sofortDa = mindestens eine versandpflichtige Einheit ist sofort versandfertig.
  // Ohne sie gibt es nichts vorab zu senden — Checkbox wäre eine sinnlose Gebühr
  // (Bug 2026-08-25: ein einzelner verzögerter Artikel zeigte die Option an).
  function updateTeil(delayedCount, pillVisible, sofortDa) {
    var row = document.querySelector('[data-hp-teil]');
    var core = window.HPDeliveryCore;
    if (row && core && core.TEIL_STR) {
      var label = row.querySelector('[data-hp-teil-label]');
      if (label) {
        var tpl = core.TEIL_STR[core.activeLocale] || core.TEIL_STR.de;
        var price = row.getAttribute('data-hp-teil-price') || 'CHF 9.90';
        // Text in EIN <span>: das Theme-Label ist flex mit ::before-Kästchen —
        // ohne Span würden Textknoten und <strong> zu eigenen Flex-Items.
        var html = '<span>' + tpl.replace('%P', '<strong>' + price + '</strong>') + '</span>';
        // Mutations-Bremse gegen den zuletzt GESCHRIEBENEN Stand, nie gegen
        // innerHTML: teilFitLabel() setzt danach style="font-size: …" auf den
        // Span, innerHTML wich dann bei JEDEM Lauf ab → Neuschreiben (childList)
        // → Drawer-Observer → run() → Endlosschleife, die Seite fror komplett ein
        // (Vorfall 14.10.2026: Handy + gemischter Korb, jede Seite ausser /cart).
        // Das Merk-Attribut ist eine Attribut-Mutation, die der Observer nicht
        // sieht; ein neu gerenderter Drawer bringt ein leeres Label ohne Attribut.
        if (label.getAttribute('data-hp-teil-html') !== html || !label.firstElementChild) {
          label.innerHTML = html;
          label.setAttribute('data-hp-teil-html', html);
        }
      }
      var hide = !(pillVisible && delayedCount > 0 && sofortDa);
      if (row.hidden !== hide) row.hidden = hide; // Mutations-Bremse
      if (label) teilFitLabel(row, label);
    }
    // Auto-Aufräumen: Gebühr liegt im Korb, aber es gibt nichts mehr zu teilen
    // (nichts verzögert ODER nichts sofort versandfertig) → Gebühren-Zeile
    // entfernen (max. 3 Versuche als Endlosschleifen-Schutz).
    if ((delayedCount === 0 || !sofortDa) && document.querySelector('[data-hp-fee-line]') && !teilBusy && teilCleanupTries < 3) {
      teilCleanupTries++;
      teilApply(false, null);
    }
    if (delayedCount > 0 && sofortDa) teilCleanupTries = 0;
  }
  // Bugfix 2026-08-09 (Zurück-Knopf von der Kasse): Der Browser kann das
  // Dokument aus dem HTTP-Cache wiederherstellen (Stand VOR dem Anhaken) und
  // nur Teile des Fussbereichs werden nachgezogen — Haken und Zeilenliste
  // widersprechen sich dann. Einmal pro Anzeige den Server-Korb gegen das DOM
  // prüfen und bei Abweichung die Drawer-Sections frisch rendern (reine
  // Anzeige-Korrektur, KEINE Cart-Mutation).
  var teilSyncDone = false;
  function teilSyncCheck() {
    if (teilSyncDone || teilBusy) return;
    // Auf der Warenkorb-SEITE immer prüfen (auch Staleness OHNE Gebühr ist dort
    // gefährlich: der Kasse-Knopf schickt das Formular mit POSITIONALEN
    // updates[]-Mengen ab — veraltete Zeilen würden Mengen auf falsche
    // Positionen schreiben). Sonst nur, wenn Teillieferungs-Kontext existiert.
    var aufCartSeite = /^\/([a-z]{2}(-[a-z]{2})?\/)?cart(\/|$)/.test(window.location.pathname);
    if (!aufCartSeite && !document.getElementById('hp-teil-checkbox') && !document.querySelector('[data-hp-fee-line]')) return;
    fetch(teilRoot() + 'cart.js', { headers: { 'Accept': 'application/json' }, cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var imKorb = (cart.items || []).some(function (i) { return i.handle === 'teillieferung'; });
        var imDom = !!document.querySelector('[data-hp-fee-line]');
        var cb = document.getElementById('hp-teil-checkbox');
        var haken = cb ? cb.checked : imDom;
        var mismatch = imKorb !== imDom || haken !== imKorb;
        if (aufCartSeite) {
          // Generischer Staleness-Test: Formularfelder vs. Server-Zeilen.
          var inputs = document.querySelectorAll('.cart-item [name="updates[]"]').length;
          if (inputs !== (cart.items || []).length) mismatch = true;
        }
        if (!mismatch) return;
        teilSyncDone = true; // höchstens EINE Korrektur pro Anzeige
        if (aufCartSeite) {
          // Main-Cart-Tabelle lässt sich nicht per renderContents patchen —
          // einmaliger, abgesicherter Reload (Schleifen-Schutz via sessionStorage).
          var KEY = 'hp-teil-cart-reload';
          var letzter = Number(sessionStorage.getItem(KEY) || 0);
          if (Date.now() - letzter < 15000) return;
          try { sessionStorage.setItem(KEY, String(Date.now())); } catch (e) {}
          window.location.reload();
          return;
        }
        var ctx = teilSections();
        if (!ctx.drawer || typeof ctx.drawer.renderContents !== 'function') return;
        return fetch(window.location.pathname + '?sections=' + encodeURIComponent(ctx.sections), { cache: 'no-store' })
          .then(function (r) { return r.json(); })
          .then(function (sections) { teilRender(ctx.drawer, { sections: sections }); });
      })
      .catch(function () {});
  }
  window.addEventListener('pageshow', function () { teilSyncDone = false; teilSyncCheck(); });

  document.addEventListener('change', function (ev) {
    var t = ev.target;
    if (!t || t.id !== 'hp-teil-checkbox') return;
    var wanted = !!t.checked;
    teilApply(wanted, function (ok) {
      // Kein optimistischer Zustand: bei Fehlschlag Haken zurücksetzen.
      if (!ok) {
        var input = document.getElementById('hp-teil-checkbox');
        if (input) input.checked = !wanted;
      }
    });
  });
  function updateCartEta() {
    var el = document.querySelector('[data-hp-cart-eta]');
    var out = document.querySelector('[data-hp-cart-eta-text]');
    var pill = document.querySelector('[data-hp-cart-eta-pill]');
    var core = window.HPDeliveryCore;
    if (!window.HPDeliveryBuckets || !core || !core.etaWindowText) return;
    // WICHTIG: Verzögerungs-Zählung und Teillieferungs-Pflege laufen auch OHNE
    // Footer-Element — die Warenkorb-SEITE (/cart) hat keinen Fussbereich, dort
    // muss das Auto-Aufräumen der Gebühren-Zeile trotzdem greifen (sonst könnte
    // ein Kunde von dort mit verwaister Gebühr zur Kasse gehen).
    var nodes = document.querySelectorAll('[data-hp-cart-delivery]');
    var slowest = null, slowestP = -1;
    // Zählregel (CART_ZUSTELLUNG_FOOTER.md): Eine Position gilt als «nicht
    // sofort», sobald ihre Menge nicht komplett aus Sofort-Bestand gedeckt ist
    // (Mengen-Split zählt) — pro Position zählt ihre langsamste Stufe.
    var totalPos = 0, delayed = [], sofortDa = false, keys = [];
    for (var i = 0; i < nodes.length; i++) {
      var buckets = window.HPDeliveryBuckets(nodes[i].getAttribute('data-vid'), currentQty(nodes[i]));
      if (!buckets || !buckets.length) continue;
      totalPos++;
      // Teillieferung braucht etwas, das man VORAB senden kann: eine sofort
      // versandfertige, versandpflichtige Einheit (Mengen-Split zählt — bei
      // Menge 2 mit 1× sofort ist Vorabsenden möglich). data-rs schliesst
      // Nicht-Versandware aus (Gebühren-Produkt selbst, Geschenkkarten).
      var versandpflichtig = nodes[i].getAttribute('data-rs') !== 'false';
      var posSlow = null, posSlowP = -1;
      for (var j = 0; j < buckets.length; j++) {
        var pcur = core.priorityOf({ label_key: buckets[j].key });
        if (pcur === 999) continue;
        if (pcur > slowestP) { slowestP = pcur; slowest = buckets[j]; }
        // Bereich bei Teillieferung nur über Versandware (Geschenkkarten und die
        // Gebühr selbst werden nicht verschickt).
        if (versandpflichtig && keys.indexOf(buckets[j].key) === -1) keys.push(buckets[j].key);
        if (buckets[j].key === 'instant' && versandpflichtig) sofortDa = true;
        if (buckets[j].key !== 'instant' && pcur > posSlowP) { posSlowP = pcur; posSlow = buckets[j]; }
      }
      if (posSlow) delayed.push(posSlow);
    }
    if (!el || !out) { updateTeil(delayed.length, false, sofortDa); return; } // Cart-SEITE: nur Aufräumen
    if (!slowest) { if (!el.hidden) el.hidden = true; setPill(pill, null); updateTeil(delayed.length, false, sofortDa); return; }
    var pillText = pillTextFor(delayed, totalPos);
    // Teillieferung wirksam (Wunsch Tobias 16.10.2026): Checkbox-Bedingung wie
    // in updateTeil UND Gebühr laut Server im Korb. Quelle ist die serverseitig
    // gerenderte Gebühren-Zeile, nie der Haken (der steht während der Anfrage
    // schon, bevor der Server bestätigt hat). Dann Bereich vom frühesten bis zum
    // spätesten Zustelldatum über alle Artikel; null (Stufe ohne Tagesfenster)
    // fällt auf den heutigen Text der langsamsten Stufe zurück.
    var teilWirksam = !!pillText && delayed.length > 0 && sofortDa && !!document.querySelector('[data-hp-fee-line]');
    var next = (teilWirksam && core.etaRangeText) ? core.etaRangeText(keys) : null;
    if (!next) next = core.etaWindowText(slowest.key, slowest.months_min, slowest.months_max);
    if (!next) { if (!el.hidden) el.hidden = true; setPill(pill, null); updateTeil(delayed.length, false, sofortDa); return; }
    // CRITICAL: only write when the value actually changed. Writing textContent
    // every run is a childList mutation that the cart-drawer MutationObserver
    // picks up → run() again → write again → infinite loop (froze the browser).
    if (out.textContent !== next) out.textContent = next;
    if (el.hidden) el.hidden = false;
    setPill(pill, pillText);
    updateTeil(delayed.length, !!pillText, sofortDa);
  }

  function run() {
    if (processing) return;
    processing = true;
    try {
      var nodes = document.querySelectorAll('[data-hp-cart-delivery]');
      for (var i = 0; i < nodes.length; i++) fill(nodes[i]);
      updateCartEta();
    } catch (e) { /* never break the cart */ }
    processing = false;
  }

  if (document.readyState !== 'loading') run();
  else document.addEventListener('DOMContentLoaded', run);

  // Bugfix 2026-07-30 (Teil 2, volle Warenkorb-SEITE /cart): Dieses Script läuft
  // als defer VOR hp-delivery-core.js; auf der Cart-Seite gibt es weder
  // Drawer-Mutationen noch Cart-Events, die run() später nochmal anstossen —
  // die SSR-Zeilen blieben dauerhaft neutral. Begrenzter Retry, bis der Katalog
  // geladen ist (global via theme.liquid, kommt also immer).
  (function waitForCore(tries) {
    if (window.HPDeliveryCore && window.HPDeliveryCore.LABEL_CATALOG) { run(); return; }
    if (tries <= 0) return;
    setTimeout(function () { waitForCore(tries - 1); }, 120);
  })(50);

  ['cart:updated', 'cart:refresh', 'cart:item-added', 'cart:change', 'on:line-item:change'].forEach(function (evt) {
    document.addEventListener(evt, run);
    window.addEventListener(evt, run);
  });

  // The cart drawer re-renders by replacing innerHTML (Section Rendering). Running
  // inside the MutationObserver callback fills the line before paint → no empty flash.
  // Scoped to the cart drawer only (was document.body) so it never reacts to unrelated
  // DOM churn elsewhere on the page (e.g. the product recommendations re-rendering) —
  // perf + avoids any side effects. The cart page relies on the cart events above.
  try {
    var scope = document.querySelector('cart-drawer') || document.getElementById('cart-drawer');
    if (scope) {
      // Notbremse (Vorfall 14.10.2026): Schreibt run() selbst Knoten in den
      // Drawer, kann jede künftige Vergleichslücke wieder eine Endlosschleife
      // auslösen. Mehr als 50 Läufe pro Sekunde sind nie echte Kunden-Aktionen:
      // dann für den Rest der Sekunde aussetzen, statt die Seite einzufrieren.
      var moWindow = 0, moRuns = 0, moWarned = false;
      var mo = new MutationObserver(function (muts) {
        var now = Date.now();
        if (now - moWindow > 1000) { moWindow = now; moRuns = 0; }
        if (++moRuns > 50) {
          if (!moWarned) { moWarned = true; console.warn('[hp-cart-delivery] Schleifen-Notbremse ausgelöst'); }
          return;
        }
        for (var i = 0; i < muts.length; i++) {
          if (muts[i].addedNodes && muts[i].addedNodes.length) { run(); return; }
        }
      });
      mo.observe(scope, { childList: true, subtree: true });
    }
  } catch (e) {}
})();
